import { ClmmPositionExpanded, RaydiumPositionExpanded, WhirlpoolPositionExpanded } from "@bridgesplit/abf-sdk";

import { AssetTypeIdentifier } from "../types";

export function isWhirlpoolPosition(clmm: ClmmPositionExpanded | null | undefined): clmm is WhirlpoolPositionExpanded {
    return !!clmm && "whirlpoolAddress" in clmm && "whirlpool" in clmm;
}

export function isRaydiumPosition(clmm: ClmmPositionExpanded | null | undefined): clmm is RaydiumPositionExpanded {
    return !!clmm && "poolAddress" in clmm && "pool" in clmm;
}

export function getClmmPositionMint(clmm: ClmmPositionExpanded | undefined): string | undefined {
    if (!clmm) return undefined;

    if (isWhirlpoolPosition(clmm)) {
        return clmm.position.positionMint;
    }

    return clmm.position.nftMint;
}

export function getClmmPoolAddress(clmm: ClmmPositionExpanded | undefined): string | undefined {
    if (!clmm) return undefined;

    if (isWhirlpoolPosition(clmm)) {
        return clmm.whirlpoolAddress;
    }

    return clmm.poolAddress;
}

export function getClmmTotalLiquidity(clmm: ClmmPositionExpanded | undefined): number | undefined {
    if (!clmm) return undefined;

    if (isWhirlpoolPosition(clmm)) {
        return clmm.position.totalLiquidity.toNumber();
    }

    return clmm.position.liquidity.toNumber();
}

export function getClmmPositionType(clmm: ClmmPositionExpanded | undefined): AssetTypeIdentifier | undefined {
    if (!clmm) return undefined;

    if (isWhirlpoolPosition(clmm)) return AssetTypeIdentifier.OrcaPosition;
    if (isRaydiumPosition(clmm)) return AssetTypeIdentifier.RaydiumPosition;
    return undefined;
}

export function getClmmPositionIdentifier(clmmPosition: ClmmPositionExpanded | undefined): string | undefined {
    if (!clmmPosition) return undefined;
    if (isWhirlpoolPosition(clmmPosition)) {
        return clmmPosition.position.whirlpool;
    }
    return clmmPosition.position.poolId;
}
